import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { IRecomendedOfferSchema } from '../../types/recommendedOffer';
import { CustomSlider } from '../Slider';
import * as styles from './BookedOfferRecommendations.css';
import { BookedOfferRecommendationItem } from './components';
import { getSettings as getSlickSettings } from './slick';
import { trackOfferClick, trackShowRecommendations } from './tracking';
import { useTrackShowMoreClick } from './useTrackShowMoreClick';

interface IBookedOfferRecommendationsProps {
  recommendations: IRecomendedOfferSchema[];
  offerId: number;
}

const SLIDES_TO_SHOW = 5;

export const BookedOfferRecommendations = (props: IBookedOfferRecommendationsProps) => {
  const { recommendations } = props;

  const slickSettings = getSlickSettings({
    totalSlides: recommendations.length,
    slidesToShow: SLIDES_TO_SHOW,
  });

  const { handleSlideChange } = useTrackShowMoreClick({
    recommendations,
    slidesToShow: SLIDES_TO_SHOW,
    offerId: props.offerId,
  });

  const handleClickOffer = React.useCallback(
    (offer: IRecomendedOfferSchema, position: number) => {
      trackOfferClick({
        offerId: props.offerId,
        position,
        recommendationId: offer.offerId,
      });
    },
    [props.offerId],
  );

  const handleShowRecommendations = React.useCallback(() => {
    const initiallyShownRecommendations = recommendations.slice(0, SLIDES_TO_SHOW).map((recommendation, index) => ({
      id: recommendation.offerId,
      position: index + 1,
    }));

    trackShowRecommendations({
      offerId: props.offerId,
      recommendations: initiallyShownRecommendations,
    });
  }, [recommendations, props.offerId]);

  if (!recommendations || recommendations.length === 0) {
    return null;
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={handleShowRecommendations} wrapper={false}>
      <section className={styles['container']} data-testid="booked-offer-recommendations" id="booked-offer-layouts">
        <UIHeading1 as="h3">Подобрали похожие</UIHeading1>
        <CustomSlider {...slickSettings} afterChange={handleSlideChange} className="similar-offers-slider">
          {recommendations.map((recommendation, index) => (
            <BookedOfferRecommendationItem
              key={recommendation.offerId}
              offer={recommendation}
              onClick={handleClickOffer}
              position={index + 1}
            />
          ))}
        </CustomSlider>
      </section>
    </ActionAfterViewObserver>
  );
};
